module.exports = __webpack_public_path__ + "img/lore.0e68a958.png";